import { render, staticRenderFns } from "./ExitLogin.vue?vue&type=template&id=18795d7f&scoped=true"
import script from "./ExitLogin.vue?vue&type=script&lang=js"
export * from "./ExitLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18795d7f",
  null
  
)

export default component.exports